import gql from 'graphql-tag';

const UPDATE_COMMENT = gql`
  mutation updateComment($data: CommentUpdateInput!, $where: CommentWhereUniqueInput!, $mentions: [ID!]) {
    updateComment(data: $data, where: $where, mentions: $mentions) {
      id
      comment
      attachedFiles {
        id
        name
        url
      }
      attachedImages {
        id
        name
        url
      }
      codeSnippet
      createdBy {
        id
        name
        avatar {
          id
          key
        }
      }
      createdAt
      task {
        id
        name
      }
    }
  }
`;

export default UPDATE_COMMENT;
